/** US states that require a 7-day notice period before termination takes effect */
export const SEVEN_DAY_STATES = ['AZ', 'CA', 'CO', 'CT', 'DC', 'HI', 'MA', 'MI', 'NH', 'NM', 'OR', 'UT', 'VT'];
